/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { ResizableBox } from "react-resizable";

import createDurationFromSeconds from "../../utils/createDurationFromSeconds";
import downloadIcon from '../../assets/imgs/inlineSvgs/download-icon.svg'

const DEFAULT_PLAY_TIME = 6;

function ItemWithAnimation({ children, isPaused, isSelected, isPlaying }) {
  return (
    <li
      className={`single-event__item ${
        isSelected ? "single-event__item--selected" : ""
      }`}
    >
      {children}
    </li>
  );
}

export default class SingleEvent extends Component {
  static propTypes = {
    event: PropTypes.shape.isRequired,
    handleEventClick: PropTypes.func
  };

  static defaultProps = {
    handleEventClick: () => {}
  };

  itemRef = React.createRef();

  state = {
    controlledSeekTime: this.props.event.seekTime || 0,
    width: 10,
    maxWidth: 200
  };

  componentDidMount() {
    this.setState({ maxWidth: this.itemRef.current.clientWidth });
  }

  extractPlayerNumber = taggedUsers => {
    const playerNumbers = [];

    if (taggedUsers && taggedUsers.length) {
      taggedUsers.map(user => playerNumbers.push(user.playerNumber));
    }

    return playerNumbers;
  };

  render() {
    const {
      event,
      handleEventClick,
      playOnProgress,
      isPaused,
      handleChangeTime,
      hasDownload
    } = this.props;
    const { isSelected, commentType, seekTime, tagedUsers, position, streamUri } = event;
    const { width, maxWidth } = this.state;


    if (this.itemRef.current) {
      this.itemRef.current.style.setProperty(
        "--play-state",
        `${isPaused ? "paused" : "running"}`
      );
    }

    const duration = createDurationFromSeconds(seekTime || 0);
    const playerNumbers = this.extractPlayerNumber(tagedUsers);

    return (
      <ul
        ref={this.itemRef}
        className={`single-event ${isSelected ? "single-event--selected" : ""}`}
        onClick={e => {
          if (
            e.target.className !== "react-resizable-handle" &&
            !this.isResize
          ) {
            if (!isPaused) {
              this.itemRef.current.style.setProperty("--bar-width", `0`);
              this.itemRef.current.style.setProperty(
                "--play-time",
                `${DEFAULT_PLAY_TIME}s`
              );
            }
            handleEventClick(event);
          } else {
            const totalWidth = this.itemRef.current.clientWidth;
            const timeFromStart = parseInt(
              (DEFAULT_PLAY_TIME / totalWidth) * this.currentWidth
            );
            const timeLeft = 6 - timeFromStart;
            this.itemRef.current.style.setProperty(
              "--play-time",
              `${timeLeft}s`
            );

            const fillBar = this.itemRef.current.getElementsByClassName(
              "fill-bar"
            )[0];
            if (fillBar) {
              fillBar.classList.add("animate");
            }

            handleChangeTime(event.seekTime + timeFromStart);
            this.isResize = false;
            setTimeout(() => {
              this.itemRef.current.style.setProperty("--bar-width", `0`);
              this.itemRef.current.style.setProperty(
                "--play-time",
                `${DEFAULT_PLAY_TIME}s`
              );
            }, timeLeft * 1000);
          }
        }}
        onMouseDown = {e => {
          if (e.target.className === "react-resizable-handle") {
            const barWidth = e.target.parentElement.clientWidth;
            this.setState({width: barWidth})

          }
        }}
      >
        <ItemWithAnimation isSelected={isSelected}>
          {duration}
        </ItemWithAnimation>
        <ItemWithAnimation isSelected={isSelected}>
          {commentType}
        </ItemWithAnimation>
        <ItemWithAnimation isSelected={isSelected}>
          {playerNumbers}
        </ItemWithAnimation>
        <ItemWithAnimation isSelected={isSelected}>
          {position.area}
        </ItemWithAnimation>
        {streamUri && hasDownload && <a href={streamUri}> <img className='single-event__icon' src={downloadIcon}/></a>}

        {isSelected && playOnProgress ? (
          <ResizableBox
            className="fill-bar animate"
            axis="x"
            width={width}
            minConstraints={[10, 150]}
            maxConstraints={[maxWidth, 300]}
            onResizeStop={(e, data) => {
              const totalWidth = this.itemRef.current.clientWidth;
              this.itemRef.current.style.setProperty(
                "--bar-width",
                `${(data.size.width / totalWidth) * 100}%`
              );
              this.currentWidth = data.size.width;
            }}
            onResizeStart={e => {
              handleChangeTime();
              this.isResize = true;
              e.target.parentElement.classList.remove("animate");
            }}
          />
        ) : null}
      </ul>
    );
  }
}
